import React from "react";
import Contents from "../components/pages/matching/en/Contents";
import Header from "../components/header/en/Header";
import Footer from "../components/footer/en/Footer";

const Matching = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default Matching;
